export default __webpack_public_path__ + "80e0fbd.svg";